var exports = {
  "k": "xf0b3b88a--92ccce--container",
  "K": "xf0b3b88a--92ccce--icon",
};

module.exports = exports;
